// extracted by mini-css-extract-plugin
export var card = "_4q-0";
export var content = "_4q-1";
export var contentLoading = "_4q-2";